import React from 'react'

import { Wrapper } from '~components/Parameters'

import ParamGroup from './ParamGroup'

const RequestParams = ({
  endpoint, 
  explorer,
  microcopy
}) => (
  <Wrapper>
    { ['path', 'query', 'body', 'header'].map(location => 
      <ParamGroup
        key={location}
        endpoint={endpoint}
        location={location}
        explorer={explorer} 
        microcopy={microcopy} />
    )}
  </Wrapper>
)

export default RequestParams